<template>
  <v-dialog
    :value="enableDialog"
    persistent
    width="600"
  >
    <validation-observer ref="observer">
      <v-card
        v-if="enableDialog"
      >
        <v-card-title>その他配車指示を入力</v-card-title>
        <v-divider />
        <v-card-text
        >
          <v-row>
            <v-col cols="12">
              <validation-provider
                v-slot="{ errors }"
                class="requiredMark"
                name="タイトル"
                rules="required|max: 30"
              >
                <v-text-field
                  v-model="forms.title"
                  :error-messages="errors"
                  dense
                  label="タイトル"
                  hide-details="auto"
                  outlined
                  persistent-placeholder
                >
                  <template v-slot:label>
                    <span>タイトル</span>
                    <span class="ml-1">
                      ({{ forms.title?.length || 0 }} / 30)
                    </span>
                  </template>
                  <template v-slot:counter></template>
                </v-text-field>
              </validation-provider>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <validation-provider
                v-slot="{ errors }"
                class="requiredMark"
                name="内容"
                rules="required|max:300"
              >
                <v-textarea
                  v-model="forms.content"
                  :error-messages="errors"
                  dense
                  hide-details="auto"
                  label="内容"
                  no-resize
                  outlined
                  persistent-placeholder
                >
                  <template v-slot:label>
                    <span>内容</span>
                    <span class="ml-1">
                      ({{ forms.content?.length || 0 }} / 300)
                    </span>
                  </template>
                  <template v-slot:counter></template>
                </v-textarea>
              </validation-provider>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-btn
            color="info"
            @click="enableHistoryButtonClickEvent"
          >
            入力履歴
          </v-btn>
          <v-spacer />
          <v-btn
            @click="closeButtonClickEvent"
          >
            閉じる
          </v-btn>
          <v-btn
            color="primary"
            @click="registerButtonClickEvent"
          >
            登録
          </v-btn>
        </v-card-actions>
      </v-card>
    </validation-observer>
    <instruction-history-dialog :enable-dialog="enableHistoryDialog" @closeEvent="closeCallback" @reflectionEvent="reflectionHistoryCallback" />
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import InstructionHistoryDialog from '@/driver/pages/allocations/dialogs/_InstructionHistoryDialog.vue'

export default {
  name: 'AllocationInstructionDialog',
  components: {
    InstructionHistoryDialog
  },
  mixins: [],
  props: {
    enableDialog: {
      type: Boolean,
      default: () => false,
    },
    targetDate: {
      type: String,
      default: () => null,
    },
    targetDriverId: {
      type: Number,
      default: () => {},
    },
    targetScheduleDetailId: {
      type: Number,
      default: () => {},
    },
  },
  data() {
    return {
      forms: {
        id: null,
        task_type: "instruction",
        title: null,
        content: null,
        sort_priority: null,
      },
      enableHistoryDialog: false,
    }
  },
  computed: {},
  watch: {
    enableDialog (newValue) {
      this.$nextTick(() => this.$refs.observer.reset())
      Object.assign(this.$data.forms, this.$options.data().forms);
      if (newValue) {
        this.setVariable()
      }
    },
  },
  created() {},
  methods: {
    ...mapActions('DriverAllocationDriverInstruction', {
      newInstruction: 'new',
      editInstruction: 'edit',
      createInstruction: 'create',
      updateInstruction: 'update',
    }),
    /**
     * 閉じるボタン クリックイベント
     * 呼び出し元のメソッドを発火
     */
    closeButtonClickEvent () {
      this.$emit('closeEvent')
    },
    enableHistoryButtonClickEvent () {
      this.enableHistoryDialog = true;
    },
    closeCallback () {
      this.enableHistoryDialog = false;
    },
    reflectionHistoryCallback (item) {
      this.forms.title = item.title
      this.forms.content = item.content
      this.closeCallback();
    },
    /**
     * 登録するボタン クリックイベント
     * データ登録を行い、呼び出し元にデータを渡す
     */
    registerButtonClickEvent () {
      let $self = this
      this.$refs.observer.validate().then((result) =>{
        if(result){
          $self.sendRegistrationInformation()
        }
      })
    },
    sendRegistrationInformation(){
      let params = {
        title: this.forms.title,
        content: this.forms.content,
      }
      if (this.targetScheduleDetailId) {
        this.updateInstruction({ driver_id: this.targetDriverId, id: this.targetScheduleDetailId, params: params }).then((content) => {
          this.$emit('registerCallback', this.targetDriverId, content)
        })
      } else {
        params['target_date'] = this.targetDate
        this.createInstruction({ driver_id: this.targetDriverId, params: params }).then((content) => {
          this.$emit('registerCallback', this.targetDriverId, content)
        })
      }
    },
    /**
     * 初期データセット
     */
    setVariable () {
      if (this.targetScheduleDetailId) {
        this.editInstruction({ driver_id: this.targetDriverId, id: this.targetScheduleDetailId }).then((content) => {
          this.forms = content
        })
      } else {
        this.newInstruction({ driver_id: this.targetDriverId }).then((content) => {
          this.forms = content
        })
      }
    }
  }
}
</script>
